module.exports = __webpack_public_path__ + "img/1_015.623c59b4.jpg";